import { render, staticRenderFns } from "./portfoliowaitforjob.vue?vue&type=template&id=04cf95b0&scoped=true&"
import script from "./portfoliowaitforjob.vue?vue&type=script&lang=js&"
export * from "./portfoliowaitforjob.vue?vue&type=script&lang=js&"
import style0 from "./portfoliowaitforjob.vue?vue&type=style&index=0&id=04cf95b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf95b0",
  null
  
)

export default component.exports